import { render, staticRenderFns } from "./winning.vue?vue&type=template&id=b2b7f828&scoped=true"
import script from "./winning.vue?vue&type=script&lang=js"
export * from "./winning.vue?vue&type=script&lang=js"
import style0 from "./winning.vue?vue&type=style&index=0&id=b2b7f828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b7f828",
  null
  
)

export default component.exports